import { useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { connect } from 'formik';

function Submit({
  isLoading,
  text = 'Submit',
  loadingText = 'Submitting',
  className = '',
  disabled = false,
  // eslint-disable-next-line no-unused-vars
  tab = false,
  // eslint-disable-next-line no-unused-vars
  setTab = false,
  marginTop = 'mt-3',
  ...props
}) {
  const { formik } = props;
  const { errors } = formik;

  // Scroll to error on submit
  useEffect(() => {
    // Wait until validation has finished, then go through errors
    if (errors && formik.isSubmitting) {
      // Function to find first error name recursively
      const errName = [];
      // eslint-disable-next-line no-inner-declarations
      function getFirstItem(obj) {
        // If an object
        if (Object.keys(obj)) {
          const key = Object.keys(obj)[0];
          errName.push(key);
          const firstItem = obj[key]; // Get the first item

          // If the first item is an array
          if (firstItem && Array.isArray(firstItem)) {
            return getFirstItem(firstItem);
          }

          // If the first item is an object
          if (firstItem && firstItem === Object(firstItem)) {
            return getFirstItem(firstItem);
          }
        }
        return null;
      }
      getFirstItem(errors);

      const element = document.getElementById(errName.join('.'));
      const element2 = document.getElementById(errName.join('')); // Alternative join
      if (element) {
        element.scrollIntoView();
      } else if (element2) {
        element2.scrollIntoView();
      }
    }
  }, [formik.isSubmitting, formik.isValidating, errors]);

  return (
    <Button
      className={`LoaderButton ${className} ${marginTop}`}
      disabled={disabled || isLoading}
      type="submit"
      {...props}
    >
      {isLoading && (
        <>
          {loadingText}
          <Spinner />
        </>
      )}
      {!isLoading && text}
    </Button>
  );
}

export default connect(Submit);
